window.MakePortraitPrintfulVariants = {
  54153272066394: 17627,
  54153272099162: 16035,
  54153272131930: 17631,
  54153272164698: 17634,
  54153272197466: 16041,
  54153272230234: 17638,
  54153272263002: 17641,
  54153272295770: 15696,
  54153272328538: 17645,
  54039377281370: 19293,
  54039377314138: 5,
  54039377346906: 19310,
  54051927851354: 9356,
  54051927884122: 9357,
  54051927916890: 9358,
  54051927949658: 11790,
  54051927982426: 11791,
  54051928015194: 11792,
  54051928047962: 10296,
  54051928080730: 10297,
  54051928113498: 10298,
  54328010244442: 17627,
  54328010277210: 16035,
  54328010309978: 17631,
  54328010342746: 17634,
  54328010375514: 16041,
  54328010408282: 17638,
  54328010441050: 17641,
  54328010473818: 15696,
  54328010506586: 17645,
  54328010834266: 19293,
  54328010867034: 5,
  54328010899802: 19310,
  54328010539354: 9356,
  54328010572122: 9357,
  54328010604890: 9358,
  54328010637658: 11790,
  54328010670426: 11791,
  54328010703194: 11792,
  54328010735962: 10296,
  54328010768730: 10297,
  54328010801498: 10298,
  54489208783194: 8947,
  54489208848730: 8948,
  54489208914266: 8952,
};
